import "./index.scss";

import { Box, CircularProgress, Grid, Modal, Stack, Tab, Tabs } from "@mui/material";
import { ReactComponent as MemberIcon } from "assets/images/icons/member.svg";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import SearchBar from "components/SearchBar";
import { GENERIC_MEMBER_STATUS_OPTIONS, MSG_OPERATION_FAILED } from "constants/index";
import CustomSelect from "containers/Members/Select";
import { stringToColor } from "helpers/utils";
import { TPagination } from "modules/api/type";
import { getNonTCAMembers } from "modules/member/memberServices";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const ExecuteCoachApproachModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [showMyMembersNotAll, setShowMyMembersNotAll] = useState(true);
  const [searchStr, setSearchStr] = useState("");
  const [options, setOptions] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [pagination, setPagination] = useState<TPagination>();
  const [params, setParams] = useState({
    limit: 20,
    my_members_only: true,
    page: 1,
    search: "",
    sort_by: "LAST_NAME",
    sort_order: "ASC",
    status: "",
  });
  const statusOptions = GENERIC_MEMBER_STATUS_OPTIONS.filter(
    (f) => f.value !== "TERMINATED" && f.value !== "IN_ACTIVE" && f.value !== "TERMINATED_FACILITY"
  );
  const defaultStatusOptions = [statusOptions[0].value];

  useEffect(() => {
    if (open && (!pagination || filterOptions.length < pagination?.total_records)) {
      setLoading(true);
      getNonTCAMembers(params)
        .then((res) => {
          if (res.success) {
            const data = searchStr ? res.data : [...options, ...res.data];
            setOptions(data);
            setFilterOptions(data);
            setPagination(res.pagination);
          } else {
            throw new Error();
          }
        })
        .catch((e) => {
          console.log(e);
          toast(MSG_OPERATION_FAILED, { type: "error" });
        })
        .finally(() => setLoading(false));
    }
  }, [open, params]);

  //#region event handlers
  const handleCloseModal = () => {
    onClose(null);
  };

  const handleChangeMembersTab = (event: React.SyntheticEvent, newValue: boolean) => {
    setOptions([]);
    setFilterOptions([]);
    setPagination(null);
    setShowMyMembersNotAll(newValue);
    setParams({ ...params, my_members_only: newValue, page: 1 });
  };

  const handleSearch = (str: string) => {
    setOptions([]);
    setFilterOptions([]);
    setPagination(null);
    setParams({ ...params, page: 1, search: str });
    setSearchStr(str);
  };

  const handleStatusChange = (values) => {
    setOptions([]);
    setFilterOptions([]);
    setPagination(null);
    setParams({ ...params, page: 1, status: values.join(",") });
  };

  const handleScroll = (e) => {
    const scrollDistance = e.target.scrollHeight - e.target.scrollTop;
    const diff = Math.abs(scrollDistance - e.target.clientHeight);
    const bottom = diff < 10;
    //console.log(
    //  `In handleScroll() scrollDistance is ${scrollDistance}, diff is ${diff}, bottom is ${bottom}, and pagination is ${pagination}`
    // );
    if (bottom && pagination) {
      if (params.page < pagination.total_pages) {
        setParams({ ...params, page: params.page + 1 });
      }
    }
  };
  //#endregion event handlers

  return (
    <Modal
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      open={open}
      onClose={() => onClose(null)}
    >
      <Stack className="personal-details-modal-container execute-coach-approach-container">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="40px"
          className="header"
        >
          <h1>Select Member</h1>
          <DeleteIcon width="24px" height="24px" onClick={handleCloseModal} />
        </Stack>
        <Tabs className="spreadTabs" value={showMyMembersNotAll} onChange={handleChangeMembersTab}>
          <Tab label="My Members" value={true} />
          <Tab label="All Members" value={false} />
        </Tabs>
        <Box className={`searchable-list-container`}>
          <Box className="header">
            <Stack direction={"row"} gap={1}>
              <SearchBar
                className="search-bar"
                value={searchStr}
                onSearch={handleSearch}
                isAsync={true}
              />
              <CustomSelect
                handler={handleStatusChange}
                options={statusOptions}
                defaultOptions={defaultStatusOptions}
              />
            </Stack>
          </Box>
          <Box className="list" onScroll={handleScroll}>
            {filterOptions.map((item, index) => (
              <button
                className={`checkable-button`}
                key={`executeCoachApproachMember${index}`}
                onClick={() => onClose(item)}
              >
                <Grid container spacing={8}>
                  <Grid item xs={4}>
                    <Stack direction="row" gap={1}>
                      <Stack
                        alignItems={"center"}
                        style={{
                          backgroundColor: stringToColor(`${item.last_name} ${item.first_name}`),
                          height: "26px",
                          padding: "2px",
                          width: "26px",
                        }}
                        className={"rounded-circle member-icon"}
                      >
                        <MemberIcon width={24} height={24} stroke={"#fff"} />
                      </Stack>
                      <Stack>
                        <Box className="value">
                          {item.last_name}, {item.first_name}
                        </Box>
                        <Box className="label">Name</Box>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack>
                      <Box className="value">{item.fitlinxx_id}</Box>
                      <Box className="label">FitLinxx ID</Box>
                    </Stack>
                  </Grid>
                  <Grid item xs={4} className="memberId">
                    <Stack>
                      <Box className="value">{`${
                        GENERIC_MEMBER_STATUS_OPTIONS.find((f) => f.value === item.status)?.label ||
                        item.status
                      }`}</Box>
                      <Box className="label">Status</Box>
                    </Stack>
                  </Grid>
                </Grid>
              </button>
            ))}
            {loading && (
              <Stack alignItems={"center"}>
                <CircularProgress disableShrink color="success" />
              </Stack>
            )}
          </Box>
        </Box>
      </Stack>
    </Modal>
  );
};

export default ExecuteCoachApproachModal;
